import axios from 'axios'
import config from '../../config'
axios.defaults.baseURL = config.api.baseUrl

export default axios